import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "file-summary" };
const _hoisted_2 = { class: "file-summary__icon" };
const _hoisted_3 = { class: "file-summary__info" };
const _hoisted_4 = ["title"];
const _hoisted_5 = {
    key: 0,
    class: "file-summary__meta"
};
import SvgIcon from "@/common/components/SvgIcon.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ContentFileSummary',
    props: {
        icon: {},
        name: {},
        meta: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(SvgIcon, { icon: __props.icon }, null, 8, ["icon"])
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", {
                        class: "file-summary__name",
                        title: __props.name
                    }, _toDisplayString(__props.name), 9, _hoisted_4),
                    (__props.meta)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.meta), 1))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
